/*!
 * JS for jp-sp plc-inspection (see KAWASAKI_ROBO-749) and duaro-2 (see KAWASAKI_ROBO_KHI-167 )
 *
 * @deps jquery,jquery.matchHeight-min
 */

const $ = jQuery;
$( function() {
	/* -----------------------------------------------------
	ヘッダー
	----------------------------------------------------- */
	$( '.header_btn' ).on( 'click', function() {
		if ( $( this ).hasClass( 'active' ) ) {
			// メニュー閉じる
			$( this ).removeClass( 'active' );
			$( 'body' ).removeClass( 'active' );
			$( '.global_nav' ).removeClass( 'active' );
		} else {
			// メニュー開く
			$( this ).addClass( 'active' );
			$( 'body' ).addClass( 'active' );
			$( '.global_nav' ).addClass( 'active' );
		}
	} );
	// メニュー内のリンクをクリックで閉じる
	$( '.global_nav a' ).on( 'click', function() {
		$( '.header_btn' ).removeClass( 'active' );
		$( 'body' ).removeClass( 'active' );
		$( '.global_nav' ).removeClass( 'active' );
	} );

	/* -----------------------------------------------------
	ページ内リンク
	----------------------------------------------------- */
	$( 'a[href^="#"]' ).on( 'click', function( event ) {
		event.preventDefault();
		const target = $( this.getAttribute( 'href' ) );
		if ( target.length ) {
			$( 'html, body' ).animate( { scrollTop: target.offset().top }, 800 );
		}
	} );

	/* -----------------------------------------------------
	よくある質問
	----------------------------------------------------- */

	const setUpAccordion = () => {
		const details = document.querySelectorAll( '.js-accordion' );
		const MOVING_VALUE = 'moving'; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
		const IS_OPENED_CLASS = 'opened'; // アイコン操作用のクラス名

		details.forEach( ( element ) => {
			const head = element.querySelector( '.js-accordion-head' );
			const content = element.querySelector( '.js-accordion-main' );

			head.addEventListener( 'click', ( event ) => {
				// デフォルトの挙動を無効化
				event.preventDefault();

				// 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
				if ( element.dataset.animStatus === MOVING_VALUE ) {
					return;
				}

				// detailsのopen属性を判定
				if ( element.open ) {
					// アコーディオンを閉じるときの処理
					// アイコン操作用クラスを切り替える(クラスを取り除く)
					element.classList.toggle( IS_OPENED_CLASS );

					// アニメーションを実行
					const closingAnim = content.animate( closingAnimKeyframes( content ), animTiming );
					// アニメーション実行中用の値を付与
					element.dataset.animStatus = MOVING_VALUE;

					// アニメーションの完了後に
					closingAnim.onfinish = () => {
						// open属性を取り除く
						element.removeAttribute( 'open' );
						// アニメーション実行中用の値を取り除く
						element.dataset.animStatus = '';
					};
				} else {
					// アコーディオンを開くときの処理
					// open属性を付与
					element.setAttribute( 'open', 'true' );

					// アイコン操作用クラスを切り替える(クラスを付与)
					element.classList.toggle( IS_OPENED_CLASS );

					// アニメーションを実行
					const openingAnim = content.animate( openingAnimKeyframes( content ), animTiming );
					// アニメーション実行中用の値を入れる
					element.dataset.animStatus = MOVING_VALUE;

					// アニメーション完了後にアニメーション実行中用の値を取り除く
					openingAnim.onfinish = () => {
						element.dataset.animStatus = '';
					};
				}
			} );
		} );
		/**
		 * アニメーションの時間とイージング
		 */
		const animTiming = {
			duration: 250,
			easing: 'ease',
		};

		/**
		 * アコーディオンを閉じるときのキーフレーム
		 *
		 * @param {Element} content
		 */
		const closingAnimKeyframes = ( content ) => [
			{
				height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
				opacity: 1,
			}, {
				height: 0,
				opacity: 0,
			},
		];

		/**
		 * アコーディオンを開くときのキーフレーム
		 *
		 * @param {Element} content
		 */
		const openingAnimKeyframes = ( content ) => [
			{
				height: 0,
				opacity: 0,
			}, {
				height: content.offsetHeight + 'px',
				opacity: 1,
			},
		];
	};
	setUpAccordion();

	/* -----------------------------------------------------
	高さ合わせ
	----------------------------------------------------- */
	const tgtSelectors = [ '.height-adjustment .top_card', '.height-adjustment .under_card' ];
	tgtSelectors.forEach( function( tgtSelector ) {
		$( tgtSelector ).matchHeight();
	} );

	$( '.flow_content_cards .card' ).matchHeight();
} );

